define.alias("shared/helpers/has-item", "media/helpers/has-item");